/**
 * This constant provides the ID's
 * of Account types.
 *
 * These are static and can be referenced in checks.
*/
export const ACCOUNT_TYPES = {
    ID_HID_MOBILE_ACCESS: 1,
    ID_EMAIL: 2,
    ID_LDAP: 3,
    ID_ACTIVE_DIRECTORY: 4,
    ID_CLICKATELL: 5,
    ID_STID_MOBILE_ID: 6,
    ID_MQTT_BROKER: 7,
    ID_VINGCARD: 8,
    ID_AUTH: 9
}

export const ACCOUNT_TYPE_SYSNAME = {
    ID_HID_MOBILE_ACCESS: "HID_MOBILE_ACCESS",
    ID_EMAIL: "SYSTEM_EMAIL",
    ID_LDAP: "LDAP",
    ID_AUTH: "AUTH",
    ID_ACTIVE_DIRECTORY: "ACTIVE_DIRECTORY",
    ID_CLICKATELL: "SMS",
    ID_STID_MOBILE_ID: "STID_MOBILE_ID",
    ID_MQTT_SERVICE: "MQTT_BROKER",
    ID_VINGCARD: "VINGCARD"
}

export const EMAIL_ACCOUNT_CONSTANTS = {
    OUTGOING_SERVER: "mail.outgoing.server",
    OUTGOING_PORT: "mail.outgoing.port",
    SSL: "mail.outgoing.starttls.enable",
    AUTH: "mail.outgoing.auth",
    INCOMING_SERVER: "mail.incoming.server",
    INCOMING_PORT: "mail.incoming.port",
    ADDRESS: "mail.address",
    USERNAME: "mail.username",
    PASSWORD: "mail.password"
}

export const HID_MOBILE_ACCESS_CONSTANTS = {
    ORG_ID: "mobile.access.org.id",
    USER_ID: "mobile.access.user.id",
    PASSWORD: "mobile.access.password",
    PART_NUMBER: "mobile.access.part.number",
    CREDENTIALS_AVAILABLE: "mobile.access.credentials.available"
}

export const STID_MOBILE_CONSTANTS = {
    USER_ID: "stid.mobile.user.id",
    PASSWORD: "stid.mobile.password",
    SITE_ID: "stid.mobile.site.id",
    CONFIGURATION_ID: "stid.mobile.configuration.id",
    CREDITS_AVAILABLE: "stid.mobile.credits.available"
}

export const LDAP_CONSTANTS = {
    CONNECTION_NAME: "ldap.connection.name",
    HOST: "ldap.host",
    BASE: "ldap.base",
    PORT: "ldap.port",
    USERNAME: "ldap.username",
    PASSWORD: "ldap.password",
    ANONYMOUS_CONNECTION: "ldap.anonymous.connection"
}

export const AUTH_CONSTANTS = {
    ISSUER: "auth.issuer",
    TENANT_ID: "auth.tenant.id",
    CLIENT_ID: "auth.client.id",
    REDIRECT_URI: "auth.redirect.uri",
    CLIENT_SECRET: "auth.client.secret",
    COOKIE_NAME: "auth.cookie.name",
    TYPE: "auth.type",
}

export const MQTT_SERVICE_CONSTANTS = {
    TLS_URL: "mqtt.tls.url",
    TLS_PORT: "mqtt.tls.port",
    CLIENT_ID: "mqtt.client.id",
    PRIMO_CERT: "mqtt.primo.cert",
    BROKER_CERT: "mqtt.broker.cert",
    BROKER_LOCATION: "mqtt.broker.location",
}

export const VINGCARD_CONSTANTS = {
    URL: "vingcard.url",
    USERNAME: "vingcard.username",
    PASSWORD: "vingcard.password",
    DEBUG_LEVEL: "vingcard.debug.level",
    POLLING_INTERVAL: "vingcard.transaction.polling.interval",
    LAST_SYNCED: "vingcard.last.synced",
    VINGCARD_CERT: "vingcard.cert",
}

export const AUTH_TYPE = {
    NOT_ACTIVE : 0,
    GENERIC: 1,
    GOOGLE: 2,
    ENTRA: 3
}
